import { INVENTORY_CATEGORIES } from '../actionTypes';

const initialState = {
  content: [],
  sortCategoryList: [],
  operatingHoursCategory: [],
  categoryItems: [],
  searchTypes: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INVENTORY_CATEGORIES.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case INVENTORY_CATEGORIES.ORDER_CATEGORIES_SUCCESS:
      return {
        ...state,
        sortCategoryList: action.payload,
      };
    case INVENTORY_CATEGORIES.FETCH_OPERATING_HOURS_SUCCESS:
      return {
        ...state,
        operatingHoursCategory: action.payload,
      };
    case INVENTORY_CATEGORIES.CATEGORY_SEARCH_SUCCESS:
      return {
        ...state,
        searchTypes: action.payload,
      };
    case INVENTORY_CATEGORIES.SUCCESS_CATEGORY:
      return {
        ...state,
        categoryItems: action.payload,
      };
    default:
      return state;
  }
};
